import { ProactiveMessageReducer as BBProactiveMessageReducer } from './proactive-message-reducer';
import { ConfigReducer as BBConfigReducer } from './config-reducer';

export default {
    bbProactiveMessages: BBProactiveMessageReducer,
    bbConfig: BBConfigReducer,
};
